export const PROFILE_KEY = 'fxpro5';
